<template>
    <div class="mt-1 py-1" 
        style="border-bottom: 1px dashed lightgray;"
    >
        <div class="flex-grow-0 flex-shrink-0 d-flex flex-row">
            <div class="form-item form-item-width-2 mb-1">
				<label class="form-item-label mt-1 mr-1">选择门店:</label>				
                <v-select
                    class="form-item-value"
                    v-model="selectedOrgId"
                    :items="orgs"						
                    label=""
                    hide-details											
                    flat
                    item-text="shopName"
                    item-value='shopId'
                    outlined
                    dense		
                    clearable	
                    multiple			
                >
                </v-select>
				
			</div>

            <div class="form-item form-item-width-1 py-0 ma-0">
                <label class="form-item-label py-0 mt-0 mr-1">收款台号:</label>
                <v-text-field 
                    class="form-item-value py-0" 								
                    outlined
                    dense
                    placeholder=""
                    v-model="sktno"
                >
                </v-text-field>						
            </div>

            <div class="form-item form-item-width-1 py-0 ma-0">
                <label class="form-item-label py-0 mt-0 mr-1">小票号:</label>
                <v-text-field 
                    class="form-item-value py-0" 								
                    outlined
                    dense
                    placeholder=""
                    v-model="fphm"
                >
                </v-text-field>						
            </div>
            
        </div>
        
        <div class="flex-grow-0 flex-shrink-0 d-flex flex-row my-0">
            <div class="form-item form-item-width-1 py-0 ma-0">
                <label class="form-item-label py-0 mt-0 mr-1">补打开始日期:</label>
                <v-menu
                    v-model="menuBeginDate"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                    class="form-item-value py-0" 	
                >
                    <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                            v-model="beginDate"
                            placeholder=""
                            readonly
                            v-bind="attrs"
                            v-on="on"
                            outlined
                            dense
                        ></v-text-field>
                    </template>
                    <v-date-picker
                        v-model="beginDate"
                        @input="menuBeginDate = false"
                        >
                    </v-date-picker>
                </v-menu>
            </div>
        
             <div class="form-item form-item-width-1 py-0 ma-0">
                <label class="form-item-label py-0 mt-0 mr-1">补打截止日期:</label>
                <v-menu
                    v-model="menuEndDate"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                    class="form-item-value py-0" 
                >
                    <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                            v-model="endDate"
                            placeholder=""
                            readonly
                            v-bind="attrs"
                            v-on="on"
                            outlined
                            dense
                        ></v-text-field>
                    </template>
                    <v-date-picker
                        v-model="endDate"
                        @input="menuEndDate = false"
                        >
                    </v-date-picker>
                </v-menu>
            </div>

            <div class="flex-grow-0 flex-shrink-0 ml-4">
                <v-btn ref="queryButton" v-if="getQueryButtonExists()" :dark="queryButtonDark" :color="queryButtonColor"
                :class="queryButtonCssClass" class="white--text"
                @click="queryClicked"
                >
                    <v-icon>{{queryButtonIcon}}</v-icon>
                    <span>{{queryButtonText}}</span>
                </v-btn>
            </div>

            <div class="flex-grow-0 flex-shrink-0 ml-1">
                <v-btn ref="queryConditionClearButton" v-if="getQueryButtonExists()" :dark="queryButtonDark" color="blue-grey"
                :class="queryConditionClearButtonCssClass" class="white--text"
                @click="queryConditionClearClicked"
                >
                    <v-icon>{{queryButtonIcon}}</v-icon>
                    <span>清除查询条件</span>
                </v-btn>
            </div>

        </div>

    </div>
</template>

<script>
    import OrgApi from "../../../../../api/smp/org/DepartmentApi.js";
    import Permission from "../../../../../api/smp/auth/Permission.js";

    export default {
        name:'SmMarketPrintcouponBackendprintQueryConditionPane',
        props:['context'],
        data () {
            return {
                name:'SmMarketPrintcouponBackendprintQueryConditionPane',
                //查询条件
                selectedOrgId:[],
                beginDate:"",
                endDate:"",
                sktno:"",
                fphm:"",

                orgs:[],
                menuBeginDate:false,
                menuEndDate:false,
            }
        },
        methods:{
            initComponent(){

            },
            initSignals(){

            },
            getModeHelper(){
                return this.context.modeHelper;
            },
            getSignals(){
                return this.context.signals;
            },
            getMessageDialogHelper(){
                return this.context.messageDialogHelper;
            },
            getQueryButtonExists(){
                return this.getModeHelper().getQueryButtonExists();
            },

            getQueryButtonPermited(){
                return this.getModeHelper().getQueryButtonPermited();
            },

            async loadOrgs(){
                let me = this;
                let queryShopPriviledgeResp = await Permission.queryShopPriviledge();
                console.log("load shop previledge returned;");

                console.log(queryShopPriviledgeResp);
                
                let data = queryShopPriviledgeResp.data;
                if((!data)||(!(data.code))||(data.code!=200)){
                    let msg=data.msg;
                    msg = ((!msg)||(msg==''))?'获取门店权限情况失败':msg;
                    throw new Error(msg);
                    return;
                }
                if((!data.data)||(!data.data.shopPriviledges)){
                    throw new Error('获取门店权限情况失败(无会话数据)');
                    return;
                }
                
                this.orgs = data.data.shopPriviledges;
            },
            queryClicked(){
                if((!this.selectedOrgId)||(this.selectedOrgId.length<1)||(!this.beginDate)||(this.beginDate=='')||(!this.endDate)||(this.endDate=='')){
                    this.getMessageDialogHelper().errMsg("错误","门店、开始/截止日期必须选择");
                    return;   
                }
                let params = {};

                console.log(this.selectedOrgId);
                
                if(this.selectedOrgId)
                    params.orgIds=this.selectedOrgId.join(',');
                    //params.orgIds=this.selectedOrgId;
                if((this.beginDate)&&(this.beginDate!=''))
                    params.beginDate = this.beginDate;
                if((this.endDate)&&(this.endDate!=''))
                    params.endDate = this.endDate;
                if((this.sktno)&&(this.sktno!=''))
                    params.sktno = this.sktno;
                if((this.fphm)&&(this.fphm!=''))
                    params.fphm = this.fphm;
                let me = this;
                this.getSignals().loadQueryResultAsked.dispatch(params);
            },
            queryConditionClearClicked(){
                this.selectedOrgId=[];
                this.sktno="";
                this.fphm="";
                this.beginDate="";
                this.endDate="";
            }
        },
        computed:{
            
            queryButtonIcon(){
                return "mdi-file-search-outline";
            },
            queryButtonText(){
                return "查询补打记录";
            },
           
            queryButtonCssClass(){
                return "ml-1 left-round";
            },

            queryButtonColor(){
                return "purple";
            },
            queryButtonDark(){
                return false;
            },

            queryConditionClearButtonCssClass(){
                return "ml-1 right-round";
            },
            

            
        },
        created(){
            this.bill = this.context.bill;
            this.signals = this.context.signals;
            this.initComponent();
            this.initSignals();
        },
        mounted(){
            console.log("SmMarketPrintcouponBackendprint.queryConditionPane loaded");
            this.loadOrgs();
        }
    }
</script>

<style scoped>
</style>
